import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import MenuItem from '@material-ui/core/MenuItem';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';

const typeOptions = [{
  label: 'EdgeWay Connect',
  value: 'ewc'
}, {
  label: 'EdgeWay Insight',
  value: 'ewi'
}];

//VEP-2142
//const hostedOptions = [{label: 'EdgeWay', value: 'EdgeWay'}, {label: 'Self', value: 'Self'}] ;
//var HOSTED_BY_SMARDTV='EdgeWay'
//const regionOptions = [{label: 'Central US', value: 'central'}, {label: 'West Europe', value: 'west europe'}];

const InfrastructureDialog = (props) => {
  const { handleType } = props;
  const [type, setType] = useState(props.type || 'ewc');
  const [name, setName] = useState(props.name || '');
  const [serverPort, setServerPort] = useState(props.server_port || '443');
  const [description, setDescription] = useState(props.description || '');
  //VEP-2142
  //const [hostedBy, setHostedBy] = useState(props.hosted_by || hostedOptions[0].value);
  //const [region, setRegion] = useState(props.region || '');
  const [vcPortStrat, setVcPortStart] = useState((props.vc_port_range && props.vc_port_range.start) || '7501');
  const [vcPortEnd, setVcPortEnd] = useState((props.vc_port_range && props.vc_port_range.end) || '7900');
  const [raPortStart, setRaPortStart] = useState((props.ra_port_range && props.ra_port_range.start) || '10000');
  const [raPortEnd, setRaPortEnd] = useState((props.ra_port_range && props.ra_port_range.end) || '10010');
  const [actionDisabled, setActionDisabled] = useState(false);
  const [proxyIp, setProxyIp] = useState(props?.proxyInfo?.url || '');
  const [proxyPort, setProxyPort] = useState(props?.proxyInfo?.port || '');
  const [proxyUserName, setProxyUserName] = useState(props?.proxyInfo?.user_name || '');
  const [proxyPassword, setProxyPassword] = useState(props?.proxyInfo?.password || '');

  const isProxyBtnDisabled = () => {
    return proxyIp === '' || proxyPort === '';
  };

  const actionByType = () => {
    if (handleType === 'create') {
      //VEP-2142
      //const disabled = !(name && ((hostedBy === HOSTED_BY_SMARDTV) ? (region) : true) && serverPort && vcPortStrat && vcPortEnd && raPortStart && raPortEnd);
      const disabled = !(name && serverPort && vcPortStrat && vcPortEnd && raPortStart && raPortEnd);
      return (
        <Button variant='contained' color='primary' disabled={disabled} autoFocus onClick={() => props.handleOk({type, name, server_port: serverPort, description, vc_port_range: { start: parseInt(vcPortStrat), end: parseInt(vcPortEnd) }, ra_port_range: { start: parseInt(raPortStart), end: parseInt(raPortEnd) }})}
        >Create
        </Button>
      );
    } else if (handleType === 'edit') {
      return null;
    } else if (handleType === 'remove' || handleType === 'setdefault') {
      const buttonTxt = (handleType === 'remove') ? 'Delete' : 'Ok';
      return (
        <Button variant='contained' color='primary' autoFocus disabled={actionDisabled} onClick={() => {setActionDisabled(true);props.handleOk();}}>{buttonTxt}</Button>
      );
    } else {
      return (
        <Button
          variant='contained'
          color='primary'
          autoFocus
          disabled={isProxyBtnDisabled()}
          onClick={() => {
            const data = {url: proxyIp, port: proxyPort, user_name: proxyUserName, password: proxyPassword};
            props.handleOk(data);
          }}>
          Save changes
        </Button>
      )
    }
  };
  const titleByType = () => {
    switch(handleType) {
    case 'create':
      return 'Create Infrastructure';
    case 'edit':
      return 'Edit Infrastructure';
    case 'remove':
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ReportProblemIcon style={{ marginRight: 8 }} />
          <Typography>Delete Infrastructure</Typography>
        </div>
      );
    case 'setdefault':
      return 'Set As Default';
    case 'configureProxy':
      return 'Proxy Settings for EWC';
    default:
      return '';
    }
  };
  const contentByType = () => {
    if (handleType === 'create') {
      return (
        <>
          <TextField select fullWidth required label='Type' value={type} onChange={e => setType(e.target.value)} disabled={handleType === 'edit'}>
            {
              typeOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))
            }
          </TextField>
          <TextField fullWidth required label='Name' value={name} onChange={e => setName(e.target.value)} disabled={handleType === 'edit'}
          />
          <TextField fullWidth required label='Server Port' value={serverPort} onChange={e => setServerPort(e.target.value)} disabled={handleType === 'edit'}
          />
          <TextField fullWidth label='Description' value={description} onChange={e => setDescription(e.target.value)} disabled={handleType === 'edit'}
          />
          {/*//VEP-2142
            <TextField select fullWidth required label='Hosted By' value={hostedBy}
            onChange={e => {
              setHostedBy(e.target.value)

              if(e.target.value != HOSTED_BY_SMARDTV) {
                setRegion('')
              }
              }}
              disabled={handleType === 'edit'}
            >
              {
                hostedOptions.map(option => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))
              }
            </TextField>*/
          }
          {/* VEP-2142
            (hostedBy === HOSTED_BY_SMARDTV) ? (
              <TextField select fullWidth required label='Hosting Region' value={region}
                onChange={e => setRegion(e.target.value)}
                disabled={handleType === 'edit'}
              >
                {
                  regionOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                }
              </TextField>
            ) : null */
          }
          <TextField fullWidth required label='VC Port Start' value={vcPortStrat} onChange={e => setVcPortStart(e.target.value)}
          />
          <TextField fullWidth required label='VC Port End' value={vcPortEnd} onChange={e => setVcPortEnd(e.target.value)}
          />
          <TextField fullWidth required label='RA Port Start' value={raPortStart} onChange={e => setRaPortStart(e.target.value)}
          />
          <TextField fullWidth required label='RA Port End' value={raPortEnd} onChange={e => setRaPortEnd(e.target.value)}
          />
        </>
      );
    } else if (handleType === 'edit') {
      return (
        <>
          <Typography>Updating this infrastructure is not allowed!</Typography>
        </>
      );
    } else if (handleType === 'remove') {
      return (
        <>
          <Typography>{'Are you sure want to delete selected infrastructure?'}</Typography>
          <Typography color='primary'>All Data related to the infrastructure will be permanently deleted.</Typography>
        </>
      );
    } else if (handleType === 'setdefault') {
      return (<Typography>{`Do you want to set '${name}' infra as default`}</Typography>);
    } else if(handleType === 'configureProxy') {
      return (
        <>
          <TextField fullWidth required label='Proxy URL' value={proxyIp} onChange={e => setProxyIp(e.target.value)} />
          <TextField fullWidth required label='Proxy server port' value={proxyPort} onChange={e => setProxyPort(e.target.value)} />
          <TextField fullWidth required label='Username' value={proxyUserName} onChange={e => setProxyUserName(e.target.value)} />
          <TextField fullWidth required label='Password' type="password" value={proxyPassword} onChange={e => setProxyPassword(e.target.value)} />
        </>
      )
    }
  };
  return (
    <Dialog
      open={props.open}
      maxWidth='xs'
      fullWidth
    >
      <DialogTitle>{titleByType()}</DialogTitle>
      <DialogContent>
        {contentByType()}
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={props.handleCancel} disabled={actionDisabled}>Cancel</Button>
        {actionByType()}
      </DialogActions>
    </Dialog>
  );
};

InfrastructureDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  handleType: PropTypes.string,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  name: PropTypes.string,
  domain_name: PropTypes.string,
  instance_id: PropTypes.string,
  public_ip: PropTypes.string,
  onvif_port_range: PropTypes.object,
  rtsp_port_range: PropTypes.object,
  webpage_port_range: PropTypes.object
};

export default InfrastructureDialog;
